<div class="flex align-items-center gap-2 mb-3">
  <span class="p-input-icon-left flex-1">
    <i class="pi pi-search"></i>
    <input pInputText type="text" class="inputfield w-full" [(ngModel)]="search"
      (ngModelChange)="applyFilter()" placeholder="Search name, email, job title or role…" />
  </span>
  <p-dropdown [options]="roles" [(ngModel)]="roleFilter" (ngModelChange)="applyFilter()"
    optionLabel="name" optionValue="id" placeholder="All roles" [showClear]="true"
    appendTo="body" [style]="{ minWidth: '13rem' }"></p-dropdown>
</div>

<div *ngIf="loading" class="text-500 py-4">Loading profiles…</div>

<!-- Every heading sorts; clicking the active one reverses it. -->
<table *ngIf="!loading" class="w-full" style="border-collapse: collapse">
  <thead>
    <tr class="text-500 text-xs">
      <th class="text-left py-2 cursor-pointer" (click)="sortBy('name')">
        Name <i class="pi" [ngClass]="sortIcon('name')" style="font-size: .7rem"></i>
      </th>
      <th class="text-left py-2 cursor-pointer" (click)="sortBy('jobTitle')">
        Job title <i class="pi" [ngClass]="sortIcon('jobTitle')" style="font-size: .7rem"></i>
      </th>
      <th class="text-left py-2 cursor-pointer" (click)="sortBy('role')">
        Role <i class="pi" [ngClass]="sortIcon('role')" style="font-size: .7rem"></i>
      </th>
      <th class="text-left py-2 cursor-pointer" (click)="sortBy('bio')">
        Bio <i class="pi" [ngClass]="sortIcon('bio')" style="font-size: .7rem"></i>
      </th>
      <th class="text-left py-2 cursor-pointer" (click)="sortBy('published')">
        Published <i class="pi" [ngClass]="sortIcon('published')" style="font-size: .7rem"></i>
      </th>
      <th class="text-left py-2 cursor-pointer" (click)="sortBy('placements')">
        Shown on <i class="pi" [ngClass]="sortIcon('placements')" style="font-size: .7rem"></i>
      </th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let u of filtered" class="surface-border border-bottom-1">
      <td class="py-2">
        <div class="font-medium">{{ u.firstName }} {{ u.lastName }}</div>
        <div class="text-500 text-sm">{{ u.email }}</div>
      </td>
      <td class="py-2 text-sm">{{ u.jobTitle || '—' }}</td>
      <td class="py-2">
        <span *ngFor="let r of roleLabels(u)"
          class="mr-1 px-2 py-1 border-round surface-200 text-xs">{{ r }}</span>
        <span *ngIf="roleLabels(u).length === 0" class="text-500 text-sm">—</span>
      </td>
      <td class="py-2">
        <i class="pi" [ngClass]="hasBio(u) ? 'pi-check text-green-600' : 'pi-minus text-500'"></i>
      </td>
      <td class="py-2">
        <span *ngIf="u.isPublicProfile" class="text-green-600 text-sm">Yes</span>
        <span *ngIf="!u.isPublicProfile" class="text-500 text-sm">No</span>
      </td>
      <td class="py-2">
        <!-- Chips are dimmed unless the profile is actually live: a placement
             on an unpublished profile is an intention, not a fact, and shown
             at full strength it reads as "this person is on that page". -->
        <span *ngFor="let p of placementLabels(u)"
          class="mr-1 px-2 py-1 border-round text-xs"
          [ngClass]="isLive(u) ? 'surface-200' : 'surface-100 text-500'">{{ p }}</span>
        <div *ngIf="isUnpublished(u)" class="text-500 text-xs mt-1">
          Not published — not on the site yet
        </div>
        <!-- The mirror case: published, but placed on no page at all. -->
        <span *ngIf="isStranded(u)" class="text-orange-600 text-xs">
          <i class="pi pi-exclamation-triangle" style="font-size: .75rem"></i>
          Published but not shown anywhere
        </span>
        <span *ngIf="!u.isPublicProfile && placementLabels(u).length === 0" class="text-500 text-sm">—</span>
      </td>
      <td class="py-2 text-right">
        <button pButton pRipple type="button" icon="pi pi-pencil" label="Edit"
          class="p-button-text p-button-sm" (click)="edit(u)"></button>
      </td>
    </tr>
    <tr *ngIf="filtered.length === 0">
      <td colspan="7" class="py-4 text-500">No profiles match that search.</td>
    </tr>
  </tbody>
</table>

<small *ngIf="!loading" class="block text-500 mt-3">
  Showing {{ filtered.length }} of {{ users.length }}.
  <strong>Published</strong> is the master switch. <strong>Shown on</strong> decides which
  pages a published profile appears on — a profile with neither is not on the site.
</small>
